export default "__VITE_ASSET__CvLEqc79__"